import api from "./api";

// Create app version
export const createAppVersion = async (appVersionData) => {
  try {
    const response = await api.post("/app-version-management/", appVersionData);

    if (response.status === 200 || response.status === 201) {
      return { success: true, data: response.data };
    } else {
      console.warn("Unexpected Response:", response);
      return { success: false, error: "Unexpected response from server" };
    }
  } catch (error) {
    console.error("Error creating app version:", error.message || error);
    return {
      success: false,
      error: error.response?.data?.detail || error.message || "Failed to create app version",
    };
  }
};

// Fetch app versions by platform
export const fetchAppVersions = async (platform) => {
  try {
    const response = await api.get(`/app-version-management/?platform=${platform}`);

    if (response.status === 200) {
      return { success: true, data: response.data };
    } else {
      console.warn("Unexpected Response:", response);
      return { success: false, error: "Unexpected response from server" };
    }
  } catch (error) {
    console.error("Error fetching app versions:", error.message || error);
    return {
      success: false,
      error: error.response?.data?.detail || error.message || "Failed to fetch app versions",
    };
  }
};

// Update app version
export const updateAppVersion = async (versionId, updateData) => {
  try {
    const response = await api.patch(`/app-version-management/${versionId}`, updateData);

    if (response.status === 200) {
      return { success: true, data: response.data };
    } else {
      console.warn("Unexpected Response:", response);
      return { success: false, error: "Unexpected response from server" };
    }
  } catch (error) {
    console.error("Error updating app version:", error.message || error);
    return {
      success: false,
      error: error.response?.data?.detail || error.message || "Failed to update app version",
    };
  }
};